import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { ComboboxOption } from "@headlessui/react-v2";
import type { MouseEvent, ReactNode } from "react";

export interface OptionProps<T = unknown> {
  children?: ReactNode;
  className?: string;
  isDisabled?: boolean;
  onClick?: (event: MouseEvent<HTMLLIElement>) => void;
  option?: T;
}

export const Option = <T,>({
  option,
  children,
  className = "",
  isDisabled = false,
  onClick,
  ...rest
}: OptionProps<T>) => (
  <ComboboxOption
    as="li"
    disabled={isDisabled}
    className={({ focus, disabled: isDisabled }) =>
      classNames(
        "text-dark relative select-none px-5 py-2 text-sm",
        {
          "bg-secondary": focus,
          "cursor-pointer": !isDisabled,
          "cursor-not-allowed opacity-50": isDisabled,
        },
        className,
      )
    }
    value={option}
    // After the migration to v2, onClick is not working as expected so we are using onMouseDown instead.
    // Eg; CreatableOption.tsx had e.preventDefault() and e.stopPropagation() to prevent the option from being selected but it stopped working as expected after the upgrade to v2.
    onMouseDown={(e: MouseEvent<HTMLLIElement>) => {
      if (e.button !== 0) return; // Ignore right click
      onClick?.(e);
    }}
    {...rest}
  >
    {children}
  </ComboboxOption>
);
